// extracted by mini-css-extract-plugin
module.exports = {"hasFtux":"trim-mode-button_hasFtux_2cA","ftux":"trim-mode-button_ftux_2Ra","ftuxContainer":"trim-mode-button_ftuxContainer_2vD"};